/* AMAANI theme JS - reveals, parallax, marquee-safe, size picker. No dependencies. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* scroll reveals */
  function initReveals() {
    var els = document.querySelectorAll('.io');
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('in'); });
    }
    var hero = document.querySelector('.aa-hero');
    if (hero) setTimeout(function () { hero.classList.add('in'); }, reduced ? 0 : 250);
  }

  /* progress bar + parallax */
  function initScroll() {
    var bar = document.querySelector('.progress');
    var plx = Array.prototype.slice.call(document.querySelectorAll('[data-plx]'));
    var ticking = false;
    function frame() {
      ticking = false;
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      if (bar) bar.style.width = (max > 0 ? (window.scrollY / max) * 100 : 0) + '%';
      if (!reduced) {
        var vh = window.innerHeight;
        plx.forEach(function (el) {
          var r = el.getBoundingClientRect();
          var mid = r.top + r.height / 2 - vh / 2;
          var f = parseFloat(el.getAttribute('data-plx')) || 0;
          el.style.setProperty('translate', '0 ' + (mid * f).toFixed(1) + 'px');
        });
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  }

  /* guided size picker (homepage band; PDP wiring lands in M3).
     Derived height bands v5.6: length = ~0.80 x height, ankle fall. */
  var CHART = {
    "52S":{c:51,sl:56},"54S":{c:51,sl:59.5},"56S":{c:54,sl:62},"58S":{c:54,sl:64},"60S":{c:56,sl:66},"62S":{c:56,sl:67},
    "52M":{c:56,sl:59},"54M":{c:56,sl:60},"56M":{c:57,sl:62},"58M":{c:57,sl:64},"60M":{c:59,sl:66},"62M":{c:59,sl:67},
    "52L":{c:59,sl:60},"54L":{c:59,sl:61},"56L":{c:59,sl:63},"58L":{c:60,sl:64.5},"60L":{c:61,sl:66},"62L":{c:61,sl:68},
    "54XL":{c:63,sl:61.5},"56XL":{c:63,sl:63.5},"58XL":{c:64,sl:65},"60XL":{c:66,sl:66},"62XL":{c:66,sl:68},
    "54XXL":{c:68,sl:62},"56XXL":{c:68,sl:64},"58XXL":{c:69,sl:65.5},"60XXL":{c:71,sl:66.5},"62XXL":{c:71,sl:68.5}
  };

  function initPicker(root) {
    var chosen = { len: null, fit: null, fitName: null };
    var code = root.querySelector('[data-res-code]');
    var expl = root.querySelector('[data-res-expl]');
    var atc = root.querySelector('[data-res-cta]');
    var ctaBase = atc ? atc.getAttribute('data-href-base') || '' : '';

    function wire(rowSel, key) {
      var row = root.querySelector(rowSel);
      if (!row) return;
      row.addEventListener('click', function (e) {
        var btn = e.target.closest('.pill'); if (!btn) return;
        row.querySelectorAll('.pill').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        if (key === 'len') { chosen.len = btn.getAttribute('data-len'); }
        else { chosen.fit = btn.getAttribute('data-fit'); chosen.fitName = btn.getAttribute('data-name'); }
        render();
      });
    }

    function render() {
      if (chosen.len && chosen.fit) {
        var key = chosen.len + chosen.fit;
        var m = CHART[key];
        if (!m) {
          code.innerHTML = '&nbsp;'; code.classList.remove('show');
          expl.textContent = chosen.fitName + ' fit starts at length 54. Choose 5\'6" to 5\'8" or taller.';
          atc.setAttribute('aria-disabled', 'true'); atc.textContent = 'Select your size'; atc.removeAttribute('href');
          return;
        }
        code.textContent = key;
        code.classList.remove('show');
        void code.offsetWidth;
        code.classList.add('show');
        expl.textContent = chosen.fitName + ' fit · chest ' + m.c + 'cm · sleeve ' + m.sl + 'cm';
        atc.removeAttribute('aria-disabled');
        atc.textContent = 'Shop thobes in ' + key;
        if (ctaBase) atc.setAttribute('href', ctaBase + (ctaBase.indexOf('?') === -1 ? '?' : '&') + 'len=' + chosen.len + '&fit=' + chosen.fit);
      } else {
        code.innerHTML = '&nbsp;'; code.classList.remove('show');
        expl.textContent = chosen.len ? 'Now choose your fit.' : (chosen.fit ? 'Now choose your height.' : 'Answer both questions and your size appears.');
        atc.setAttribute('aria-disabled', 'true'); atc.textContent = 'Select your size'; atc.removeAttribute('href');
      }
    }
    wire('[data-row-height]', 'len');
    wire('[data-row-fit]', 'fit');
  }

  /* ---------- M3: PDP with guided size picker ---------- */
  var SIZE_RE = /^(\d{2})(S|M|L|XL|XXL|XXXL)$/;
  var LEN_BANDS = { '52': 'Under 5\'6"', '54': '5\'6" to 5\'8"', '56': '5\'8" to 5\'11"', '58': '5\'11" to 6\'1"', '60': '6\'1" to 6\'4"', '62': 'Over 6\'4"' };
  var FIT_NAMES = { S: 'Tailored', M: 'Classic', L: 'Relaxed', XL: 'Generous', XXL: 'Grand', XXXL: 'Grand+' };
  var FIT_ORDER = ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  /* Kids are sized as a bare number with no fit letter, so SIZE_RE never matched
     them: on the Kids collection the filter panel came up with no size row at all.
     Ages mirror assets/size-charts.json (toddlers 18-30, boys 32-50). */
  var KID_AGES = {
    '18': '6 mo', '20': '6 to 11 mo', '22': '12 mo', '24': '1.5 to 2 yrs',
    '26': '2.5 yrs', '28': '3 yrs', '30': '3.5 yrs',
    '32': '3 yrs', '34': '4 yrs', '36': '5 yrs', '38': '6 yrs', '40': '7 yrs',
    '42': '8 to 9 yrs', '44': '9 to 10 yrs', '46': '10 to 11 yrs',
    '48': '11 to 12 yrs', '50': '13 to 14 yrs'
  };

  function initProductForm(root) {
    var dataEl = root.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('input[name="id"]');
    var btn = root.querySelector('button[type="submit"].buy-btn');
    var priceEl = root.querySelector('[data-price]');
    var chosen = {};

    var sizeRow = root.querySelector('[data-opt-size]');
    var sizePos = sizeRow ? parseInt(sizeRow.getAttribute('data-opt-row'), 10) : null;
    var sizeValues = sizeRow ? Array.prototype.map.call(sizeRow.querySelectorAll('.opt'), function (b) { return b.getAttribute('data-val'); }) : [];
    var codedCount = sizeValues.filter(function (v) { return SIZE_RE.test(v); }).length;
    var guided = !!sizeRow && sizeValues.length > 5 && codedCount >= sizeValues.length * 0.8;
    var gLen = null, gFit = null;

    function othersMatch(v) {
      return Object.keys(chosen).every(function (pos) {
        if (guided && parseInt(pos, 10) === sizePos) return true;
        return v.options[pos - 1] === chosen[pos];
      });
    }
    function variantForSize(val) {
      return variants.find(function (v) { return v.options[sizePos - 1] === val && othersMatch(v); });
    }
    function comboAvailable(len, fit) {
      var v = variantForSize(len + fit);
      return !!(v && v.available);
    }

    var lens = [], fits = [];
    sizeValues.forEach(function (v) {
      var m = SIZE_RE.exec(v);
      if (!m) return;
      if (lens.indexOf(m[1]) === -1) lens.push(m[1]);
      if (fits.indexOf(m[2]) === -1) fits.push(m[2]);
    });
    lens.sort();
    fits.sort(function (a, b) { return FIT_ORDER.indexOf(a) - FIT_ORDER.indexOf(b); });

    /* generic option rows (colour etc; size row too when not guided) */
    /* seed from the server-selected variant so ?variant= deep links (Merchant
       Center, ads, shared links) keep their price and selection on screen */
    var seedVariant = variants.find(function (v) { return String(v.id) === String(idInput.value); }) || null;

    root.querySelectorAll('[data-opt-row]').forEach(function (row) {
      var pos = row.getAttribute('data-opt-row');
      var isGuidedSize = guided && parseInt(pos, 10) === sizePos;
      var seedVal = seedVariant ? seedVariant.options[pos - 1] : null;
      var target = seedVal ? Array.prototype.find.call(row.querySelectorAll('.opt'), function (o) { return o.getAttribute('data-val') === seedVal; }) : null;
      if (!target && !isGuidedSize) target = row.querySelector('.opt');
      if (target && !isGuidedSize) { chosen[pos] = target.getAttribute('data-val'); target.setAttribute('aria-pressed', 'true'); }
      if (target && isGuidedSize && seedVal && location.search.indexOf('variant=') !== -1) {
        /* explicit variant deep link: preselect the size too */
        chosen[pos] = seedVal;
        target.setAttribute('aria-pressed', 'true');
        var sm = SIZE_RE.exec(seedVal);
        if (sm) { gLen = sm[1]; gFit = sm[2]; }
      }
      row.addEventListener('click', function (e) {
        var b = e.target.closest('.opt'); if (!b) return;
        row.querySelectorAll('.opt').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        chosen[pos] = b.getAttribute('data-val');
        if (guided && parseInt(pos, 10) === sizePos) {
          var m = SIZE_RE.exec(chosen[pos]);
          /* a size picked straight off the grid is the strongest signal there is */
          if (m) { gLen = m[1]; gFit = m[2]; userPicked = true; memHold = false; memWrite(gLen, gFit); }
        }
        if (guided) renderGuided(); else resolve();
        var imgV = variants.find(function (v) { return v.img && othersMatch(v); });
        if (imgV && root.galleryShowUrl) root.galleryShowUrl(imgV.img);
      });
    });

    function setPrice(v) {
      if (priceEl) priceEl.textContent = v.price;
      var cmp = document.querySelector('[data-product-form] [data-compare]');
      if (cmp) { if (v.compare) { cmp.textContent = v.compare; cmp.hidden = false; } else { cmp.hidden = true; } }
    }
    function resolve() {
      var match = variants.find(function (v) {
        return Object.keys(chosen).every(function (pos) { return v.options[pos - 1] === chosen[pos]; });
      });
      if (match) {
        idInput.value = match.id;
        setPrice(match);
        btn.disabled = !match.available;
        btn.textContent = match.available ? 'Add to cart' : 'Sold out';
      } else {
        btn.disabled = true;
        btn.textContent = 'Unavailable';
      }
    }

    /* bakhoor, oud, tasbeeh and anything else without coded sizes still gets the
       sticky bar; only the guided picker is thobe-specific */
    if (!guided) { resolve(); initStickyBuy(root, btn); initSizeModal(root, null); return; }

    /* ---- guided UI ---- */
    var mount = root.querySelector('[data-guided-mount]');
    var sgBtn = root.querySelector('[data-open-sizeguide]');
    if (sgBtn) sgBtn.hidden = false;
    /* the classic grid is the MAIN selector (always visible); guided steps are the helper */

    var html = '<div data-guided-steps hidden><div class="gstep"><span class="steplab-lite">Your height</span><div class="optrow" data-glen>';
    lens.forEach(function (l) {
      html += '<button type="button" class="opt opt-tall" data-len="' + l + '" aria-pressed="false"><b>' + l + '</b><span class="sub">' + (LEN_BANDS[l] || '') + '</span></button>';
    });
    html += '</div></div><div class="gstep"><span class="steplab-lite">Your fit</span><div class="optrow" data-gfit>';
    fits.forEach(function (f) {
      html += '<button type="button" class="opt opt-tall" data-fit="' + f + '" aria-pressed="false"><b>' + (FIT_NAMES[f] || f) + '</b><span class="sub">' + f + '</span></button>';
    });
    html += '</div></div></div>' +
      '<p class="gnote" data-gnote>Select your size, or let us find it.</p>' +
      '<button type="button" class="linklike" data-toggle-guided>Don\'t know your size?</button>';
    mount.innerHTML = html;
    /* order: grid (in liquid, below mount) is primary; note + helper link follow it visually */
    var sizeBlock = sizeRow.parentElement;
    sizeBlock.insertBefore(sizeRow, mount);

    var lenRow = mount.querySelector('[data-glen]');
    var fitRow = mount.querySelector('[data-gfit]');
    var note = mount.querySelector('[data-gnote]');
    var steps = mount.querySelector('[data-guided-steps]');
    var guidedToggle = mount.querySelector('[data-toggle-guided]');

    /* ---------- size memory ----------
       Sizing is the single most asked question on WhatsApp, and Amaani's two part
       length + fit system means a shopper resolves it once and then repeats the work
       on every thobe. We remember what they resolved and offer it back.

       It OFFERS by default rather than selecting: Hamza deliberately removed
       auto-preselect so nobody adds a size they never chose. A remembered size is a
       far better guess than a default, but it is still a guess on a different cut,
       so the shopper taps to accept. The behaviour is a theme setting, not a
       hardcode, so it can be switched to auto without touching this file. */
    var MEM_KEY = 'aa_size', MEM_DAYS = 180;
    var memMode = (root.getAttribute('data-size-memory') || 'prompt');
    var userPicked = false;
    var memHold = false;   /* set when the shopper accepted a sold-out substitute */

    function memRead() {
      if (memMode === 'off') return null;
      try {
        var m = JSON.parse(window.localStorage.getItem(MEM_KEY) || 'null');
        if (!m || !m.len || !m.fit) return null;
        if (m.t && Date.now() - m.t > MEM_DAYS * 864e5) return null;
        return m;
      } catch (e) { return null; }           /* private mode / storage disabled */
    }
    function memWrite(len, fit) {
      if (memMode === 'off') return;
      try {
        window.localStorage.setItem(MEM_KEY, JSON.stringify({ len: len, fit: fit, t: Date.now() }));
      } catch (e) {}
    }

    var recall = document.createElement('p');
    recall.className = 'gnote gmem';
    recall.hidden = true;
    note.parentNode.insertBefore(recall, note);

    /* ---------- back in stock ----------
       A sold-out size is the moment the shopper is most willing to leave a number.
       We capture it into the portal's Back in Stock queue, where a person messages
       them on WhatsApp when it returns. Nothing is sent automatically. */
    var notifyUrl = root.getAttribute('data-notify-endpoint') || '';
    var pHandle = root.getAttribute('data-product-handle') || '';
    var pImage = root.getAttribute('data-product-image') || '';
    var notifyWrap = document.createElement('div');
    notifyWrap.className = 'bis';
    notifyWrap.hidden = true;
    note.parentNode.insertBefore(notifyWrap, note.nextSibling);
    var notifyFor = null;             /* the size code the shopper is waiting on */

    function notifyOffer(code) {
      if (!notifyUrl) { notifyWrap.hidden = true; return; }
      notifyFor = code;
      notifyWrap.innerHTML = '<button type="button" class="linklike" data-bis-open>Tell me when ' + code + ' is back</button>';
      notifyWrap.hidden = false;
    }

    notifyWrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-bis-open]')) {
        notifyWrap.innerHTML =
          '<label class="bis-lab" for="bis-wa">Your WhatsApp number</label>' +
          '<div class="bis-row">' +
            '<input id="bis-wa" class="bis-input" type="tel" inputmode="tel" autocomplete="tel" placeholder="082 123 4567">' +
            '<button type="button" class="buy-btn bis-send" data-bis-send>Notify me</button>' +
          '</div>' +
          '<p class="bis-note">We will message you on WhatsApp when ' + notifyFor + ' is back. Nothing else.</p>';
        var f = notifyWrap.querySelector('#bis-wa'); if (f) f.focus();
        return;
      }
      var send = e.target.closest('[data-bis-send]');
      if (!send) return;
      var input = notifyWrap.querySelector('#bis-wa');
      var num = (input.value || '').replace(/\D/g, '');
      if (num.length < 9) {
        var w = notifyWrap.querySelector('.bis-note');
        w.textContent = 'That number looks short. Please check it and try again.';
        w.classList.add('bis-err'); input.focus();
        return;
      }
      send.disabled = true; send.textContent = 'Sending';
      var v = variantForSize(notifyFor);
      fetch(notifyUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          whatsapp: input.value,
          handle: pHandle,
          product: (root.querySelector('.buybox h1') || {}).textContent || '',
          variantId: v ? String(v.id) : null,
          variantLabel: notifyFor,
          imageUrl: pImage
        })
      }).then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (d) {
          if (d && d.ok) {
            notifyWrap.innerHTML = '<p class="bis-done">Done. We will WhatsApp you when ' + notifyFor + ' is back.</p>';
          } else {
            throw new Error((d && d.error) || 'failed');
          }
        })
        .catch(function (err) {
          notifyWrap.innerHTML = '<p class="bis-note bis-err">' +
            (String(err.message).indexOf('valid') !== -1 ? err.message : 'That did not go through. Please try again, or message us on WhatsApp.') +
            '</p>';
        });
    });

    recall.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mem-use]'); if (!b) return;
      var code = SIZE_RE.exec(b.getAttribute('data-mem-use'));
      if (!code) return;
      /* Taking the SUBSTITUTE we offered because their size was sold out must not
         overwrite their real size, or one out-of-stock colourway silently rewrites
         what we think they wear. Only an unchanged recall confirms the memory. */
      var m = memRead();
      memHold = !!(m && (m.len !== code[1] || m.fit !== code[2]));
      gLen = code[1]; gFit = code[2];
      userPicked = true;
      recall.hidden = true;
      renderGuided();
    });

    function renderRecall() {
      /* once they have touched a size on this page, memory has nothing to add */
      if (userPicked || (gLen && gFit)) { recall.hidden = true; return; }
      var m = memRead();
      if (!m) { recall.hidden = true; return; }
      var code = m.len + m.fit;
      if (sizeValues.indexOf(code) === -1) { recall.hidden = true; return; }  /* not made in this cut */

      var v = variantForSize(code);
      var label = 'Last time you chose <b>' + code + '</b>';
      if (v && v.available) {
        recall.innerHTML = label + '. <button type="button" class="linklike" data-mem-use="' + code + '">Use it</button>';
      } else {
        /* same +2 then -2 search the sold-out flow already uses, so the two agree */
        var alt = null;
        [2, -2].some(function (d) {
          var cand = String(parseInt(m.len, 10) + d);
          if (lens.indexOf(cand) !== -1 && comboAvailable(cand, m.fit)) { alt = cand; return true; }
          return false;
        });
        if (alt) {
          recall.innerHTML = label + ', sold out in this colour. ' +
            '<button type="button" class="linklike" data-mem-use="' + alt + m.fit + '">Try ' + alt + m.fit + '</button>' +
            ' · same fit, 5cm ' + (parseInt(alt, 10) > parseInt(m.len, 10) ? 'longer' : 'shorter') + '.';
        } else {
          recall.innerHTML = label + ', sold out in this colour.';
        }
      }
      recall.hidden = false;
    }

    guidedToggle.addEventListener('click', function () {
      steps.hidden = !steps.hidden;
      guidedToggle.textContent = steps.hidden ? 'Don\'t know your size?' : 'Hide the size finder';
    });

    lenRow.addEventListener('click', function (e) {
      var b = e.target.closest('[data-len]'); if (!b) return;
      gLen = b.getAttribute('data-len');
      userPicked = true; memHold = false;
      renderGuided();
    });
    note.addEventListener('click', function (e) {
      var b = e.target.closest('[data-suggest-len]'); if (!b) return;
      gLen = b.getAttribute('data-suggest-len');
      renderGuided();
    });
    fitRow.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fit]'); if (!b) return;
      gFit = b.getAttribute('data-fit');
      userPicked = true; memHold = false;
      renderGuided();
    });

    function renderGuided() {
      renderRecall();
      sizeRow.querySelectorAll('.opt').forEach(function (p) {
        var pv = variantForSize(p.getAttribute('data-val'));
        p.classList.toggle('unavail', !(pv && pv.available));
      });
      lenRow.querySelectorAll('[data-len]').forEach(function (b) {
        var l = b.getAttribute('data-len');
        b.setAttribute('aria-pressed', l === gLen ? 'true' : 'false');
        var any = fits.some(function (f) { return comboAvailable(l, f); });
        b.classList.toggle('unavail', !any);
      });
      fitRow.querySelectorAll('[data-fit]').forEach(function (b) {
        var f = b.getAttribute('data-fit');
        b.setAttribute('aria-pressed', f === gFit ? 'true' : 'false');
        var ok = gLen ? comboAvailable(gLen, f) : lens.some(function (l) { return comboAvailable(l, f); });
        b.classList.toggle('unavail', !ok);
      });

      if (gLen && gFit) {
        var code = gLen + gFit;
        var exists = sizeValues.indexOf(code) !== -1;
        var v = exists ? variantForSize(code) : null;
        /* remember a real size the shopper resolved, even if it is sold out in THIS
           colour: it is still their size, and the next product may well have it */
        if (userPicked && exists && !memHold) memWrite(gLen, gFit);
        chosen[sizePos] = code;
        sizeRow.querySelectorAll('.opt').forEach(function (p) { p.setAttribute('aria-pressed', p.getAttribute('data-val') === code ? 'true' : 'false'); });
        var meas = CHART[code];
        if (!exists) {
          note.textContent = (FIT_NAMES[gFit] || gFit) + ' fit is not made in length ' + gLen + '. Try the next length up.';
          notifyWrap.hidden = true;
          btn.disabled = true; btn.textContent = 'Unavailable';
          return;
        }
        if (v && v.available) {
          note.textContent = 'Size ' + code + (meas ? ' \u00B7 chest ' + meas.c + 'cm \u00B7 sleeve ' + meas.sl + 'cm' : '');
          notifyWrap.hidden = true;
          idInput.value = v.id;
          setPrice(v);
          btn.disabled = false;
          btn.textContent = 'Add to cart';
        } else {
          /* sold out or missing: recommend nearest length in the same fit (+2 first, then -2) */
          var altLen = null;
          [2, -2].some(function (d) {
            var cand = String(parseInt(gLen, 10) + d);
            if (lens.indexOf(cand) !== -1 && comboAvailable(cand, gFit)) { altLen = cand; return true; }
            return false;
          });
          btn.disabled = true;
          btn.textContent = v ? 'Sold out in this colour' : 'Unavailable';
          /* only worth offering on a size that really exists and is simply out */
          if (v) notifyOffer(code); else notifyWrap.hidden = true;
          if (altLen) {
            var dir = parseInt(altLen, 10) > parseInt(gLen, 10) ? 'longer' : 'shorter';
            note.innerHTML = code + ' is sold out in this colour. ' +
              '<button type="button" class="linklike gsuggest" data-suggest-len="' + altLen + '">Try ' + altLen + gFit + '</button>' +
              ' \u00B7 same fit, 5cm ' + dir + ', in stock.';
          } else {
            var pTitle = (root.querySelector('.buybox h1') || {textContent: 'this thobe'}).textContent.trim();
            var colourBits = Object.keys(chosen).filter(function (pos) { return parseInt(pos, 10) !== sizePos; })
              .map(function (pos) { return chosen[pos]; }).join(', ');
            var waMsg = 'Assalamu Alaikum, can you check stock of the ' + pTitle + ' in ' + code + (colourBits ? ' (' + colourBits + ')' : '') + ' for me?';
            var waLink = document.querySelector('.foot-wa-link');
            var waBase = waLink ? waLink.getAttribute('href').split('?')[0] : 'https://wa.me/27742622642';
            note.innerHTML = code + ' is sold out in this colour. ' +
              '<a class="linklike" target="_blank" rel="noopener" href="' + waBase + '?text=' + encodeURIComponent(waMsg) + '">Check stock for me on WhatsApp</a>';
          }
        }
      } else {
        note.textContent = gLen ? 'Now choose your fit.' : (gFit ? 'Now choose your height.' : 'Select your size, or let us find it.');
        notifyWrap.hidden = true;
        btn.disabled = true; btn.textContent = 'Select your size';
      }
    }
    /* 'auto' mode: only ever seeds a size that is actually buyable here, and never
       overrides an explicit ?variant= deep link (which has already set gLen/gFit) */
    if (memMode === 'auto' && !gLen && !gFit) {
      var seed = memRead();
      if (seed && sizeValues.indexOf(seed.len + seed.fit) !== -1 && comboAvailable(seed.len, seed.fit)) {
        gLen = seed.len; gFit = seed.fit;
      }
    }

    renderGuided();
    initStickyBuy(root, btn);
    initSizeModal(root, function () { return gLen && gFit ? gLen + gFit : null; });
  }

  /* ---- mobile sticky buy bar ----
     Shows once the real Add to cart has scrolled away, so the price and the action
     stay reachable down a long product page. It holds NO state of its own: it mirrors
     the real button's label and disabled state and forwards taps to it, so the picker
     stays the single source of truth. When no size is chosen yet it sends the shopper
     back to the picker rather than sitting there dead. */
  function initStickyBuy(root, realBtn) {
    var bar = root.querySelector('[data-sticky-buy]');
    if (!bar || !realBtn) return;
    var sbBtn = bar.querySelector('[data-sticky-add]');
    var sbPrice = bar.querySelector('[data-sticky-price]');
    var priceEl = root.querySelector('[data-price]');
    var sizeRow = root.querySelector('[data-opt-size]');

    function sync() {
      sbBtn.disabled = realBtn.disabled;
      sbBtn.textContent = realBtn.textContent;
      if (priceEl && sbPrice) sbPrice.textContent = priceEl.textContent;
    }
    /* the picker rewrites the real button directly, so watch it rather than trying
       to hook every code path that can change it */
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(realBtn, {
        childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled']
      });
      if (priceEl) new MutationObserver(sync).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
    sync();

    sbBtn.addEventListener('click', function () {
      if (realBtn.disabled) {
        /* nothing chosen yet: take them to the sizes instead of doing nothing */
        var target = sizeRow || realBtn;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        bar.classList.add('sb-nudge');
        setTimeout(function () { bar.classList.remove('sb-nudge'); }, 700);
        return;
      }
      realBtn.click();
    });

    function show(on) {
      bar.hidden = !on;
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    /* Deliberately geometry on scroll rather than IntersectionObserver: IO only fires
       when a threshold is CROSSED, so landing past the button already scrolled (a deep
       link, or the browser restoring scroll position on back) produces no callback at
       all and the bar would never appear. rAF-throttled, same pattern as initScroll. */
    var ticking = false;
    function evaluate() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      if (!vh) return;                       /* nothing sensible to decide against yet */
      show(realBtn.getBoundingClientRect().bottom < 0);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(evaluate); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', onScroll);
    /* IO as a second trigger, never as the decision: it is efficient for the normal
       scroll-through, while the scroll listener covers the case it cannot see, where
       the page loads already past the button and no threshold is ever crossed. The
       geometry check above is the single source of truth for both. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(onScroll, { threshold: 0 }).observe(realBtn);
    }
    onScroll();
  }

  /* ---- recently viewed ----
     History lives in localStorage as handles only. Cards are then rebuilt from
     /products/<handle>.js at render time rather than from a stored snapshot, so a
     price change, a sell-out or a deleted product can never be shown stale: a
     product that 404s simply drops out of the list. */
  var RECENT_KEY = 'aa_recent', RECENT_CAP = 12;

  function recentRead() {
    try {
      var v = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) { return []; }
  }
  function recentRecord(handle) {
    if (!handle) return;
    try {
      var list = recentRead().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_CAP)));
    } catch (e) {}
  }

  function money(cents) {
    /* Shopify .js prices are integer cents; match the storefront's R 1,399.00 shape */
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'R ' + n;
  }

  function initRecentlyViewed(sec) {
    var grid = sec.querySelector('[data-recent-grid]');
    var current = sec.getAttribute('data-recent-current') || '';
    var max = parseInt(sec.getAttribute('data-recent-max'), 10) || 4;

    /* record the current product first, then show the others: a shopper should never
       be recommended the page they are already on */
    recentRecord(current);
    var handles = recentRead().filter(function (h) { return h !== current; }).slice(0, max);
    if (handles.length < 2) return;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var live = items.filter(function (p) { return p && p.available !== undefined; });
      if (live.length < 2) return;
      grid.innerHTML = live.map(function (p) {
        var img = p.featured_image ? String(p.featured_image).replace(/(\.[a-z]+)(\?|$)/i, '_480x$1$2') : '';
        var title = (p.title || '').replace(/^Amaani /, '');
        var cmp = (p.compare_at_price && p.compare_at_price > p.price)
          ? '<s>' + money(p.compare_at_price) + '</s> ' : '';
        return '<div class="xs-card">' +
            '<a href="/products/' + p.handle + '"><div class="frame in">' +
              (img ? '<img src="' + img + '" alt="' + title.replace(/"/g, '&quot;') + '" width="480" height="623" loading="lazy">' : '') +
            '</div></a>' +
            '<div class="meta"><div>' +
              '<h3><a href="/products/' + p.handle + '">' + title + '</a></h3>' +
              '<span class="price">' + cmp + money(p.price) + '</span>' +
            '</div>' +
            '<a class="xs-add" href="/products/' + p.handle + '">View</a>' +
            '</div></div>';
      }).join('');
      sec.hidden = false;
      /* the band is revealed after the observer has already run, so show it outright */
      sec.classList.add('in');
    });
  }

  /* ---- colourways strip ----
     One listing per colourway on this store, so the other colours of a model are
     separate products. Pair them the way structured-data.liquid already does for
     Google: strip the colour words from the title and whatever is left is the
     model. Products whose model matches this page's are its sisters. */
  function initColourways(root) {
    var wrap = root.querySelector('[data-colourways]');
    if (!wrap) return;

    var words = (wrap.getAttribute('data-colour-words') || '')
      .split(',')
      .reduce(function (out, entry) {
        /* the collection filter's "White = Alabaster / Ivory" fold syntax is
           accepted here too, flattened: every name matches, and the label keeps
           whichever name the title actually uses */
        entry.split('=').forEach(function (half) {
          half.split('/').forEach(function (w) { if (w.trim()) out.push(w.trim()); });
        });
        return out;
      }, [])
      .sort(function (a, b) { return b.length - a.length; });
    if (!words.length) return;

    function escRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

    /* title -> { group, colour }. Longest phrases claim their span first, so
       Light Grey never reads as Grey; a colour matches only as a whole word. */
    function splitTitle(title) {
      var t = ' ' + (title || '') + ' ';
      var hits = [];
      words.forEach(function (w) {
        var re = new RegExp('[\\s-]' + escRe(w) + '(?=[\\s-])', 'gi');
        var m;
        while ((m = re.exec(t))) {
          var start = m.index + 1, end = start + w.length;
          var covered = hits.some(function (h) { return start < h.end && end > h.start; });
          if (!covered) hits.push({ start: start, end: end });
        }
      });
      hits.sort(function (a, b) { return a.start - b.start; });
      var group = '', pos = 0;
      hits.forEach(function (h) { group += t.slice(pos, h.start); pos = h.end; });
      group += t.slice(pos);
      /* "Urban Thobe Black with Brown" leaves a dangling "with"; "Musallah - Red"
         a dangling "-". Same cleanups as the JSON-LD. */
      group = group.replace(/\s+with\s+/gi, ' ').replace(/\s+/g, ' ').trim().replace(/[\s-]+$/, '');
      return {
        group: group.toLowerCase(),
        colour: hits.map(function (h) { return t.slice(h.start, h.end); }).join(' / ')
      };
    }

    function tagColour(tags) {
      /* colour:Black tags cover the five all-black listings with no colour word
         in the title */
      for (var i = 0; i < (tags || []).length; i++) {
        var m = /^colou?r\s*[:\-]\s*(.+)$/i.exec(String(tags[i]).trim());
        if (m) return m[1].trim();
      }
      return '';
    }

    function hasColourOption(p) {
      return (p.options || []).some(function (o) {
        var n = ((typeof o === 'string' ? o : o && o.name) || '').trim().toLowerCase();
        return n === 'colour' || n === 'color';
      });
    }

    var myHandle = root.getAttribute('data-product-handle') || '';
    var mine = splitTitle(wrap.getAttribute('data-product-title'));
    var myColour = mine.colour || tagColour((wrap.getAttribute('data-product-tags') || '').split(','));
    if (!mine.group || !myColour) return;

    /* one slim catalogue index per session: handle, title, first image, stock */
    function loadIndex() {
      var KEY = 'aa_cw_idx';
      try {
        var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (c && c.t && Date.now() - c.t < 600000 && c.items) return Promise.resolve(c.items);
      } catch (e) { /* private mode */ }
      var all = [];
      function page(n) {
        return fetch('/products.json?limit=250&page=' + n)
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (d) {
            var ps = d.products || [];
            all = all.concat(ps.map(function (p) {
              return {
                h: p.handle,
                t: p.title,
                img: (p.images && p.images[0]) ? p.images[0].src : '',
                av: (p.variants || []).some(function (v) { return v.available; }),
                tg: tagColour(p.tags),
                co: hasColourOption(p)
              };
            }));
            if (ps.length === 250 && n < 6) return page(n + 1);
            return all;
          });
      }
      return page(1).then(function (items) {
        try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
        return items;
      });
    }

    loadIndex().then(function (items) {
      var sisters = items.filter(function (p) {
        if (p.h === myHandle || p.co || !p.img) return false;
        var sp = splitTitle(p.t);
        if (!sp.group || sp.group !== mine.group) return false;
        p._col = sp.colour || p.tg;
        return !!p._col;
      });
      if (!sisters.length) return;

      var row = wrap.querySelector('[data-cw-row]');
      var cur = wrap.querySelector('[data-cw-current]');
      if (cur) cur.textContent = ': ' + myColour;

      function make(tag, cls, img, w) {
        var el = document.createElement(tag);
        el.className = cls;
        var im = document.createElement('img');
        im.src = img ? img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=' + w : '';
        im.alt = ''; im.width = 200; im.loading = 'lazy';
        el.appendChild(im);
        return el;
      }
      /* this page's colourway first, marked, not a link */
      var me = make('span', 'cw-item is-current', root.getAttribute('data-product-image'), 0);
      me.querySelector('img').src = root.getAttribute('data-product-image') || '';
      me.setAttribute('aria-current', 'page');
      me.title = myColour;
      row.appendChild(me);
      sisters.forEach(function (p) {
        var a = make('a', 'cw-item' + (p.av ? '' : ' cw-soldout'), p.img, 200);
        a.href = '/products/' + p.h;
        a.title = p._col + (p.av ? '' : ' (sold out)');
        a.setAttribute('aria-label', 'This design in ' + p._col + (p.av ? '' : ', currently sold out'));
        row.appendChild(a);
      });
      wrap.removeAttribute('hidden');
    }).catch(function () { /* strip simply stays hidden */ });
  }

  /* ---- size guide modal ---- */
  function initSizeModal(root, currentCode) {
    var openBtn = root.querySelector('[data-open-sizeguide]');
    var modal = document.querySelector('[data-size-modal]');
    var overlay = document.querySelector('[data-modal-overlay]');
    if (!openBtn || !modal) return;
    var chartUrl = root.getAttribute('data-chart-url');
    var chart = null;

    function close() {
      modal.classList.remove('open'); overlay.classList.remove('open');
      setTimeout(function () { modal.hidden = true; overlay.hidden = true; }, 320);
    }
    modal.querySelectorAll('[data-modal-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

    function cell(x) { return '<td>' + (x === undefined ? '' : x) + '</td>'; }
    function renderTables(tab) {
      var el = modal.querySelector('[data-sm-tables]');
      var active = currentCode ? currentCode() : null;
      if (tab === 'adults') {
        var out = '';
        ['S', 'M', 'L', 'XL', 'XXL'].forEach(function (fit) {
          var grp = chart.adults[fit]; if (!grp) return;
          out += '<h4>' + (FIT_NAMES[fit] || fit) + ' <span>' + fit + '</span></h4>';
          out += '<div class="sm-scroll"><table><tr><th>Size</th><th>Length</th><th>Shoulder</th><th>Sleeve</th><th>Chest</th><th>Waist</th><th>Hip</th><th>Collar</th></tr>';
          Object.keys(grp).sort().forEach(function (code) {
            var r = grp[code];
            out += '<tr' + (code === active ? ' class="hl"' : '') + '><td><b>' + code + '</b></td>' +
              cell(r.length) + cell(r.shoulder) + cell(r.sleeve) + cell(r.chest) + cell(r.waist) + cell(r.hip) + cell(r.collar) + '</tr>';
          });
          out += '</table></div>';
        });
        el.innerHTML = out;
      } else {
        var grp2 = chart[tab];
        var out2 = '<div class="sm-scroll"><table><tr><th>Size</th><th>Age</th><th>Length</th><th>Shoulder</th><th>Sleeve</th><th>Chest</th></tr>';
        Object.keys(grp2).sort(function (a, b) { return a - b; }).forEach(function (code) {
          var r = grp2[code];
          out2 += '<tr><td><b>' + code + '</b></td>' + cell(r.age) + cell(r.length) + cell(r.shoulder) + cell(r.sleeve) + cell(r.chest) + '</tr>';
        });
        el.innerHTML = out2 + '</table></div>';
      }
    }

    modal.querySelectorAll('.sm-tab').forEach(function (t) {
      t.addEventListener('click', function () {
        modal.querySelectorAll('.sm-tab').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        t.setAttribute('aria-pressed', 'true');
        renderTables(t.getAttribute('data-tab'));
      });
    });

    openBtn.addEventListener('click', function () {
      modal.hidden = false; overlay.hidden = false;
      void modal.offsetWidth;
      modal.classList.add('open'); overlay.classList.add('open');
      if (chart) { renderTables('adults'); return; }
      fetch(chartUrl).then(function (r) { return r.json(); }).then(function (d) { chart = d; renderTables('adults'); }).catch(function () {});
    });
  }


  /* ---------- M4: collection filters + sort ---------- */
  function initCollectionTools(tools) {
    var handle = tools.getAttribute('data-coll-handle');
    var section = tools.closest('.aa-collection');
    var panel = section.querySelector('[data-filter-panel]');
    var toggleBtn = tools.querySelector('[data-filter-toggle]');
    var clearBtn = tools.querySelector('[data-filter-clear]');
    var countEl = tools.querySelector('[data-filter-count]');
    var sortSel = tools.querySelector('[data-sort-select]');
    var serverGrid = section.querySelector('[data-server-grid]');
    var clientGrid = section.querySelector('[data-client-grid]');
    var emptyEl = section.querySelector('[data-filter-empty]');
    var pagination = section.querySelector('[data-server-pagination]');
    var products = null, loading = false;
    var sel = { len: [], fit: [], kid: [], col: [], stock: false };

    var params = new URLSearchParams(location.search);
    if (sortSel && params.get('sort_by')) sortSel.value = params.get('sort_by');
    if (sortSel) sortSel.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sortSel.value);
      ['len', 'fit', 'kid', 'col', 'stock'].forEach(function (k) { u.searchParams.delete(k); });
      location.href = u.toString();
    });

    /* dress the native select in the brand: custom trigger + quiet menu */
    if (sortSel) {
      var sortWrap = sortSel.closest('.ct-sort');
      sortSel.classList.add('visually-hidden');
      var trig = document.createElement('button');
      trig.type = 'button';
      trig.className = 'sort-trigger';
      trig.setAttribute('aria-haspopup', 'listbox');
      trig.setAttribute('aria-expanded', 'false');
      var menu = document.createElement('div');
      menu.className = 'sort-menu';
      menu.hidden = true;
      menu.setAttribute('role', 'listbox');
      function syncTrig() {
        trig.innerHTML = sortSel.options[sortSel.selectedIndex].textContent + '<i>&#9662;</i>';
      }
      function buildMenu() {
        menu.innerHTML = '';
        Array.prototype.forEach.call(sortSel.options, function (o) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('role', 'option');
          b.setAttribute('aria-selected', String(o.value === sortSel.value));
          b.textContent = o.textContent;
          b.addEventListener('click', function () {
            sortSel.value = o.value;
            sortSel.dispatchEvent(new Event('change'));
          });
          menu.appendChild(b);
        });
      }
      function closeMenu() { menu.classList.remove('open'); menu.hidden = true; trig.setAttribute('aria-expanded', 'false'); }
      trig.addEventListener('click', function (e) {
        e.stopPropagation();
        if (menu.hidden) {
          buildMenu();
          menu.hidden = false; void menu.offsetWidth; menu.classList.add('open');
          trig.setAttribute('aria-expanded', 'true');
        } else closeMenu();
      });
      document.addEventListener('click', function (e) { if (!sortWrap.contains(e.target)) closeMenu(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
      syncTrig();
      sortWrap.appendChild(trig);
      sortWrap.appendChild(menu);
    }

    function sizeParts(v, sizeIdx) {
      var raw = sizeIdx !== -1 ? (v['option' + (sizeIdx + 1)] || '') : '';
      var m = SIZE_RE.exec(raw);
      if (m) return { len: m[1], fit: m[2] };
      var k = raw.trim();
      if (KID_AGES[k]) return { kid: k };
      return null;
    }

    /* Colour is recorded three ways across the catalogue: a real Colour option (a
       handful of products), a colour:<name> tag, or the tail of the title (most of
       them). Read all three in that order so one filter covers the whole grid. */
    function lc(s) { return (s || '').trim().toLowerCase(); }
    var COLOUR_WORDS = (tools.getAttribute('data-colour-words') || '')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean)
      .map(function (entry) {
        /* "White = Alabaster / Ivory": the first name is the pill, the rest are other
           names for the same shade and fold into it */
        var bits = entry.split('=');
        return {
          name: bits[0].trim(),
          all: [bits[0].trim()].concat((bits[1] || '').split('/').map(function (s) { return s.trim(); }).filter(Boolean))
        };
      });

    function canonical(c) {
      c = (c || '').trim();
      for (var i = 0; c && i < COLOUR_WORDS.length; i++) {
        if (COLOUR_WORDS[i].all.map(lc).indexOf(lc(c)) !== -1) return COLOUR_WORDS[i].name;
      }
      return c;
    }

    function colourOptIdx(p) {
      var opts = p.options || [];
      for (var i = 0; i < opts.length; i++) {
        /* "Button Color" is hardware, not the garment */
        var n = lc(opts[i].name);
        if (n === 'colour' || n === 'color') return i;
      }
      return -1;
    }

    function coloursOf(p) {
      if (p._aaCols) return p._aaCols;
      var out = [];
      function add(c) {
        c = canonical(c);
        if (c && out.map(lc).indexOf(lc(c)) === -1) out.push(c);
      }
      (p.tags || []).forEach(function (t) {
        var m = /^colou?r\s*[:\-]\s*(.+)$/i.exec(String(t).trim());
        if (m) add(m[1]);
      });
      if (!out.length) {
        var ci = colourOptIdx(p);
        if (ci !== -1) (p.variants || []).forEach(function (v) { add(v['option' + (ci + 1)]); });
      }
      if (!out.length) {
        var t = ' ' + lc(p.title) + ' ';
        var hits = [];
        COLOUR_WORDS.forEach(function (e) {
          e.all.forEach(function (phrase) {
            if (t.indexOf(' ' + lc(phrase) + ' ') !== -1) hits.push({ phrase: phrase, name: e.name });
          });
        });
        /* a two-word colour wins over the one inside it: Light Grey, not Grey */
        hits.filter(function (h) {
          return !hits.some(function (o) {
            return o.phrase.length > h.phrase.length && (' ' + lc(o.phrase) + ' ').indexOf(' ' + lc(h.phrase) + ' ') !== -1;
          });
        }).forEach(function (h) { add(h.name); });
      }
      p._aaCols = out;
      return out;
    }

    function fetchAll() {
      if (products || loading) return Promise.resolve(products);
      loading = true;
      var all = [];
      function page(n) {
        return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n)
          .then(function (r) { return r.json(); })
          .then(function (d) {
            all = all.concat(d.products || []);
            if ((d.products || []).length === 250 && n < 8) return page(n + 1);
            products = all;
            return products;
          });
      }
      return page(1).finally(function () { loading = false; });
    }

    function optIdx(p, names) {
      for (var i = 0; i < (p.options || []).length; i++) {
        var n = (p.options[i].name || '').toLowerCase();
        if (names.indexOf(n) !== -1) return i;
      }
      return -1;
    }

    function buildPanel() {
      var lens = [], fits = [], cols = [], kids = [];
      products.forEach(function (p) {
        var si = optIdx(p, ['size']);
        (p.variants || []).forEach(function (v) {
          var sp = sizeParts(v, si);
          if (sp && sp.kid) {
            if (kids.indexOf(sp.kid) === -1) kids.push(sp.kid);
          } else if (sp) {
            if (lens.indexOf(sp.len) === -1) lens.push(sp.len);
            if (fits.indexOf(sp.fit) === -1) fits.push(sp.fit);
          }
        });
        coloursOf(p).forEach(function (c) {
          if (cols.map(lc).indexOf(lc(c)) === -1) cols.push(c);
        });
      });
      lens.sort();
      kids.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
      fits.sort(function (a, b) { return FIT_ORDER.indexOf(a) - FIT_ORDER.indexOf(b); });
      /* house order first, anything unlisted after it, alphabetically */
      var colOrder = COLOUR_WORDS.map(function (e) { return lc(e.name); });
      cols.sort(function (a, b) {
        var ia = colOrder.indexOf(lc(a)), ib = colOrder.indexOf(lc(b));
        if (ia === -1) ia = colOrder.length;
        if (ib === -1) ib = colOrder.length;
        return ia - ib || (a < b ? -1 : a > b ? 1 : 0);
      });
      var html = '';
      if (lens.length) {
        html += '<div class="fp-row"><span class="steplab-lite">Length</span><div class="optrow">' +
          lens.map(function (l) { return '<button type="button" class="opt opt-tall" data-f="len" data-v="' + l + '" aria-pressed="false"><b>' + l + '</b><span class="sub">' + (LEN_BANDS[l] || '') + '</span></button>'; }).join('') + '</div></div>';
      }
      if (fits.length) {
        html += '<div class="fp-row"><span class="steplab-lite">Fit</span><div class="optrow">' +
          fits.map(function (f) { return '<button type="button" class="opt opt-tall" data-f="fit" data-v="' + f + '" aria-pressed="false"><b>' + (FIT_NAMES[f] || f) + '</b><span class="sub">' + f + '</span></button>'; }).join('') + '</div></div>';
      }
      if (kids.length) {
        html += '<div class="fp-row"><span class="steplab-lite">Kids size</span><div class="optrow">' +
          kids.map(function (k) { return '<button type="button" class="opt opt-tall" data-f="kid" data-v="' + k + '" aria-pressed="false"><b>' + k + '</b><span class="sub">' + (KID_AGES[k] || '') + '</span></button>'; }).join('') + '</div></div>';
      }
      if (cols.length && cols.length <= 14) {
        html += '<div class="fp-row"><span class="steplab-lite">Colour</span><div class="optrow">' +
          cols.map(function (c) { return '<button type="button" class="opt" data-f="col" data-v="' + c.replace(/"/g, '&quot;') + '" aria-pressed="false">' + c + '</button>'; }).join('') + '</div></div>';
      }
      html += '<div class="fp-row"><div class="optrow"><button type="button" class="opt" data-f="stock" data-v="1" aria-pressed="false">In stock only</button></div></div>';
      if (!lens.length && !fits.length && !kids.length && !cols.length) html = '<p class="caption">No filters for this collection.</p>';
      panel.innerHTML = html;

      panel.addEventListener('click', function (e) {
        var b = e.target.closest('[data-f]'); if (!b) return;
        var f = b.getAttribute('data-f'), v = b.getAttribute('data-v');
        if (f === 'stock') { sel.stock = !sel.stock; b.setAttribute('aria-pressed', String(sel.stock)); }
        else {
          var arr = sel[f]; var i = arr.indexOf(v);
          if (i === -1) arr.push(v); else arr.splice(i, 1);
          b.setAttribute('aria-pressed', String(i === -1));
        }
        apply();
      });
    }

    function matches(p) {
      var si = optIdx(p, ['size']);
      var ci = colourOptIdx(p);
      /* no colour option: the product carries one colour, so judge it whole */
      if (sel.col.length && ci === -1) {
        var pcols = coloursOf(p).map(lc);
        if (!sel.col.some(function (c) { return pcols.indexOf(lc(c)) !== -1; })) return false;
      }
      /* a size pick means "show me what I can buy in my size": a thobe that only
         has 58M sold out must not come up for 58M, so sizes always imply stock */
      var sized = sel.len.length || sel.fit.length || sel.kid.length;
      return (p.variants || []).some(function (v) {
        var sp = sizeParts(v, si);
        if (sel.len.length && (!sp || sel.len.indexOf(sp.len) === -1)) return false;
        if (sel.fit.length && (!sp || sel.fit.indexOf(sp.fit) === -1)) return false;
        if (sel.kid.length && (!sp || !sp.kid || sel.kid.indexOf(sp.kid) === -1)) return false;
        if (sel.col.length && ci !== -1 && sel.col.map(lc).indexOf(lc(canonical(v['option' + (ci + 1)]))) === -1) return false;
        if ((sel.stock || sized) && !v.available) return false;
        return true;
      });
    }

    function money2(cents) { return money(cents, window.Shopify && Shopify.currency ? Shopify.currency.active : 'ZAR'); }

    function cardHTML(p) {
      var img = (p.images && p.images[0]) ? p.images[0].src : '';
      if (img) img = img.replace(/(\.[a-z]+)(\?|$)/, '_740x$1$2');
      var anyAvail = (p.variants || []).some(function (v) { return v.available; });
      var v0 = p.variants && p.variants[0] ? p.variants[0] : null;
      var price = v0 ? Math.round(parseFloat(v0.price) * 100) : 0;
      var cmp = v0 && v0.compare_at_price && parseFloat(v0.compare_at_price) > parseFloat(v0.price) ? Math.round(parseFloat(v0.compare_at_price) * 100) : 0;
      return '<a class="pcard" href="/products/' + p.handle + '">' +
        '<div class="frame in">' + (img ? '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" width="740" height="960" loading="lazy">' : '') + '</div>' +
        '<div class="meta"><h3>' + (p.title || '').replace('Amaani ', '') + '</h3>' +
        (anyAvail ? '<span class="price">' + (cmp ? '<s>' + money2(cmp) + '</s> ' : '') + money2(price) + '</span>' : '<span class="price sold">Sold out</span>') + '</div></a>';
    }

    function anyActive() { return sel.len.length || sel.fit.length || sel.kid.length || sel.col.length || sel.stock; }

    function apply() {
      var u = new URL(location.href);
      ['len', 'fit', 'kid', 'col'].forEach(function (k) {
        if (sel[k].length) u.searchParams.set(k, sel[k].join(',')); else u.searchParams.delete(k);
      });
      if (sel.stock) u.searchParams.set('stock', '1'); else u.searchParams.delete('stock');
      history.replaceState(null, '', u.toString());

      if (!anyActive()) {
        clientGrid.hidden = true; serverGrid.hidden = false; emptyEl.hidden = true;
        if (pagination) pagination.hidden = false;
        countEl.hidden = true; clearBtn.hidden = true;
        return;
      }
      var hits = products.filter(matches);
      serverGrid.hidden = true;
      if (pagination) pagination.hidden = true;
      clientGrid.hidden = false;
      clientGrid.innerHTML = hits.map(cardHTML).join('');
      emptyEl.hidden = hits.length > 0;
      countEl.textContent = hits.length + (hits.length === 1 ? ' piece' : ' pieces');
      countEl.hidden = false;
      clearBtn.hidden = false;
    }

    clearBtn.addEventListener('click', function () {
      sel = { len: [], fit: [], kid: [], col: [], stock: false };
      panel.querySelectorAll('[data-f]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      apply();
    });

    toggleBtn.addEventListener('click', function () {
      var opening = panel.hidden;
      if (opening) {
        panel.hidden = false;
        toggleBtn.setAttribute('aria-expanded', 'true');
        fetchAll().then(function () { if (!panel.dataset.built) { buildPanel(); panel.dataset.built = '1'; restoreFromUrl(); } });
      } else {
        panel.hidden = true;
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
    });

    function restoreFromUrl() {
      var p2 = new URLSearchParams(location.search);
      ['len', 'fit', 'kid', 'col'].forEach(function (k) {
        var v = p2.get(k); if (v) sel[k] = v.split(',');
      });
      sel.stock = p2.get('stock') === '1';
      var any = anyActive();
      panel.querySelectorAll('[data-f]').forEach(function (b) {
        var f = b.getAttribute('data-f'), v = b.getAttribute('data-v');
        var on = f === 'stock' ? sel.stock : sel[f].indexOf(v) !== -1;
        b.setAttribute('aria-pressed', String(on));
      });
      if (any) apply();
    }

    /* deep-linked filters: open panel automatically */
    if (['len', 'fit', 'kid', 'col', 'stock'].some(function (k) { return params.get(k); })) {
      toggleBtn.click();
    }
  }

  /* ---------- cart page: live quantity, remove and note ---------- */
  function initCartPage() {
    var root = document.querySelector('[data-cart-page]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');

    /* Quantity is applied optimistically and the requests are coalesced: tapping
       "+" three times fast shows 4 straight away and sends one update, instead of
       three requests that each read a stale number back out of the DOM.
       /cart/update.js takes the whole line-ordered array, so a removal in the same
       breath cannot renumber the other lines out from under us. */
    var pending = {}, timer = null, inFlight = false;

    function swap(data) {
      var html = data && data.sections && data.sections[sectionId];
      if (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-page]');
        if (fresh) root.innerHTML = fresh.innerHTML;
      }
      if (data && typeof data.item_count === 'number') setCartCount(data.item_count);
    }

    function flush() {
      if (inFlight) return;
      var lines = Array.prototype.slice.call(root.querySelectorAll('[data-line]'));
      if (!lines.length) { pending = {}; return; }
      var updates = lines.map(function (el) {
        var n = parseInt(el.getAttribute('data-line'), 10);
        if (pending[n] !== undefined) return pending[n];
        var q = el.querySelector('.qty b');
        return q ? parseInt(q.textContent, 10) : 1;
      });
      pending = {};
      inFlight = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates, sections: sectionId, sections_url: location.pathname })
      }).then(function (r) { return r.json(); })
        .then(swap)
        .catch(function () {
          root.querySelectorAll('[data-busy]').forEach(function (el) { el.removeAttribute('data-busy'); });
        })
        .finally(function () {
          inFlight = false;
          if (Object.keys(pending).length) flush();
        });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-q]'); if (!btn) return;
      var lineEl = btn.closest('[data-line]'); if (!lineEl) return;
      e.preventDefault();
      var line = parseInt(lineEl.getAttribute('data-line'), 10);
      var qEl = lineEl.querySelector('.qty b');
      var base = pending[line] !== undefined ? pending[line] : (qEl ? parseInt(qEl.textContent, 10) : 1);
      var dq = parseInt(btn.getAttribute('data-q'), 10);
      var next = dq === 0 ? 0 : Math.max(1, base + dq);
      pending[line] = next;
      if (next === 0) lineEl.setAttribute('data-busy', '');
      else if (qEl) qEl.textContent = next;
      clearTimeout(timer);
      timer = setTimeout(flush, 320);
    });

    var noteTimer = null;
    root.addEventListener('input', function (e) {
      var ta = e.target.closest('[data-cart-note]'); if (!ta) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: ta.value })
        }).then(function () {
          var flag = root.querySelector('[data-note-saved]');
          if (!flag) return;
          flag.hidden = false;
          setTimeout(function () { flag.hidden = true; }, 2200);
        }).catch(function () {});
      }, 600);
    });
  }

  /* ---------- M4: predictive search overlay ---------- */
  function initSearchOverlay() {
    var overlay = document.querySelector('[data-search-overlay]');
    if (!overlay) return;
    var input = overlay.querySelector('[data-search-input]');
    var results = overlay.querySelector('[data-search-results]');
    var timer = null;

    function open(e) {
      if (e) e.preventDefault();
      overlay.hidden = false;
      void overlay.offsetWidth;
      overlay.classList.add('open');
      setTimeout(function () { input.focus(); }, 60);
    }
    function close() {
      overlay.classList.remove('open');
      setTimeout(function () { overlay.hidden = true; }, 320);
    }
    document.querySelectorAll('[data-search-open]').forEach(function (a) { a.addEventListener('click', open); });
    overlay.querySelector('[data-search-close]').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });

    /* Same relevance rule the results page uses: a suggestion is an exact match
       only when every typed word appears in the title, type, vendor or tags.
       Shopify pads thin queries with fuzzy hits, so sort those to the bottom
       rather than letting an adult thobe head the list for "kids". */
    var esc = escHtml;
    function relevance(p, terms) {
      var hay = [p.title, p.product_type, p.vendor, (p.tags || []).join(' ')].join(' ').toLowerCase();
      return terms.every(function (t) {
        var stem = t.length > 3 && t.slice(-1) === 's' ? t.slice(0, -1) : t;
        return hay.indexOf(stem) !== -1;
      }) ? 1 : 0;
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (((d.resources || {}).results || {}).products) || [];
            if (!items.length) { results.innerHTML = '<p class="caption so-none">Nothing found for "' + esc(q) + '"</p>'; return; }
            var terms = q.toLowerCase().split(/\s+/).filter(function (t) { return t.length > 1; });
            var exact = [], near = [];
            items.forEach(function (p) { (relevance(p, terms) ? exact : near).push(p); });
            function row(p) {
              return '<a class="so-item" href="' + esc(p.url) + '">' +
                (p.image ? '<img src="' + esc(p.image) + '" alt="" width="44" height="57" loading="lazy">' : '<span class="so-noimg"></span>') +
                '<span class="so-t">' + esc(p.title.replace('Amaani ', '')) + '</span>' +
                '<span class="so-p">' + (p.price ? money(Math.round(parseFloat(p.price) * 100)) : '') + '</span></a>';
            }
            var html = exact.map(row).join('');
            if (near.length) {
              html += (exact.length ? '<p class="caption so-near">Also in the house</p>' : '');
              html += near.map(row).join('');
            }
            html += '<a class="so-all textlink" href="/search?type=product&q=' + encodeURIComponent(q) + '">See all results</a>';
            results.innerHTML = html;
          }).catch(function () {});
      }, 220);
    });
  }


  /* ---------- gallery: main image + thumbs + lightbox ---------- */
  function initGallery(root) {
    var gal = root.querySelector('[data-gallery]');
    if (!gal) return;
    var main = gal.querySelector('[data-main-img]');
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-thumb]'));
    var cells = Array.prototype.slice.call(gal.querySelectorAll('[data-gidx]'));
    var srcs = cells.length ? cells.map(function (c) { return c.querySelector('img').getAttribute('data-large'); })
             : thumbs.length ? thumbs.map(function (t) { return t.getAttribute('data-large'); })
             : (main ? [main.src] : []);
    var idx = 0, lb = null;

    function setMain(i) {
      idx = i;
      if (main) main.src = srcs[i];
      thumbs.forEach(function (t, k) { t.setAttribute('aria-pressed', String(k === i)); });
    }
    root.galleryShowUrl = function (url) {
      var path = url.split('?')[0];
      var i = srcs.findIndex(function (s) { return s.split('?')[0] === path; });
      if (i === -1) return;
      setMain(i);
      cells.forEach(function (c, k) { c.classList.toggle('g-active', k === i); });
      clearTimeout(root._ringTimer);
      root._ringTimer = setTimeout(function () {
        if (cells[i]) cells[i].classList.remove('g-active');
      }, 1600);
      if (cells[i] && getComputedStyle(cells[i]).display !== 'none') {
        cells[i].scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    };
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { setMain(i); });
    });

    function renderLb() {
      lb.querySelector('img').src = srcs[idx].replace(/width=\d+/, 'width=1800');
      lb.querySelector('[data-lb-count]').textContent = (idx + 1) + ' / ' + srcs.length;
    }
    function closeLb() {
      if (lb) { document.body.removeChild(lb); lb = null; }
      document.documentElement.classList.remove('drawer-open');
    }
    function openLb() {
      lb = document.createElement('div');
      lb.className = 'aa-lightbox';
      lb.innerHTML = '<button class="lb-close" aria-label="Close">&times;</button>' +
        '<button class="lb-prev" aria-label="Previous">&larr;</button>' +
        '<img alt="">' +
        '<button class="lb-next" aria-label="Next">&rarr;</button>' +
        '<span class="caption" data-lb-count></span>';
      document.body.appendChild(lb);
      document.documentElement.classList.add('drawer-open');
      renderLb();
      lb.querySelector('.lb-close').addEventListener('click', closeLb);
      lb.querySelector('.lb-prev').addEventListener('click', function () { setMain((idx - 1 + srcs.length) % srcs.length); renderLb(); });
      lb.querySelector('.lb-next').addEventListener('click', function () { setMain((idx + 1) % srcs.length); renderLb(); });
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    }
    document.addEventListener('keydown', function (e) {
      if (!lb) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowLeft') { setMain((idx - 1 + srcs.length) % srcs.length); renderLb(); }
      if (e.key === 'ArrowRight') { setMain((idx + 1) % srcs.length); renderLb(); }
    });
    if (main) {
      main.style.cursor = 'zoom-in';
      main.addEventListener('click', openLb);
    }
    cells.forEach(function (c, i) {
      c.addEventListener('click', function () { idx = i; openLb(); });
    });
  }


  /* ---------- rotating quotes ---------- */
  function initQuotes() {
    var root = document.querySelector('[data-quotes]');
    if (!root) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('.quote-slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-qdot]'));
    if (slides.length < 2) return;
    var i = 0, timer = null;
    function show(n) {
      i = n % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('active', k === i); });
      dots.forEach(function (d, k) { d.setAttribute('aria-pressed', String(k === i)); });
    }
    function start() { if (!reduced) timer = setInterval(function () { show(i + 1); }, 7000); }
    function stop() { clearInterval(timer); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { stop(); show(k); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  }


  /* ---------- Nikah gift box add-on ---------- */
  function initAddon(root) {
    var box = root.querySelector('[data-addon]');
    if (!box) return;
    var variants = JSON.parse(box.querySelector('[data-addon-json]').textContent);
    var check = box.querySelector('[data-addon-check]');
    var opts = box.querySelector('[data-addon-opts]');
    var img = box.querySelector('[data-addon-img]');
    var sel = {};
    box.querySelectorAll('[data-addon-row]').forEach(function (row) {
      var pos = row.getAttribute('data-addon-row');
      sel[pos] = row.querySelector('.opt').getAttribute('data-val');
      row.addEventListener('click', function (e) {
        var b = e.target.closest('.opt'); if (!b) return;
        row.querySelectorAll('.opt').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        sel[pos] = b.getAttribute('data-val');
        resolveAddon();
      });
    });
    function resolveAddon() {
      var v = variants.find(function (v) {
        return v.available && Object.keys(sel).every(function (pos) { return v.options[pos - 1] === sel[pos]; });
      });
      root.addonVariantId = (check.checked && v) ? v.id : null;
      if (v && v.img && img) img.src = v.img;
      bundleNote(root);
    }
    check.addEventListener('change', function () {
      opts.hidden = !check.checked;
      box.classList.toggle('open', check.checked);
      resolveAddon();
    });
    if (img) zoomable(img);
    resolveAddon();
  }

  function zoomable(img) {
    img.style.cursor = 'zoom-in';
    img.addEventListener('click', function () {
      var lb = document.createElement('div');
      lb.className = 'aa-lightbox';
      lb.innerHTML = '<button class="lb-close" aria-label="Close">&times;</button><img alt="">';
      lb.querySelector('img').src = img.src.replace(/width=\d+/, 'width=1800');
      document.body.appendChild(lb);
      document.documentElement.classList.add('drawer-open');
      function closeZoom() {
        if (lb.parentNode) document.body.removeChild(lb);
        document.documentElement.classList.remove('drawer-open');
        document.removeEventListener('keydown', onKey);
      }
      function onKey(ev) { if (ev.key === 'Escape') closeZoom(); }
      lb.querySelector('.lb-close').addEventListener('click', closeZoom);
      lb.addEventListener('click', function (ev) { if (ev.target === lb) closeZoom(); });
      document.addEventListener('keydown', onKey);
    });
  }

  function bundleNote(root) {
    var n = root.querySelector('[data-bundle-note]');
    if (n) n.hidden = !(root.addonVariantId && root.oudVariantId);
  }

  function initAddonOud(root) {
    var box = root.querySelector('[data-addon-oud]');
    if (!box) return;
    var check = box.querySelector('[data-oud-check]');
    var opts = box.querySelector('[data-oud-opts]');
    var img = box.querySelector('[data-oud-img-preview]');
    var priceEl = box.querySelector('[data-oud-price]');
    var pills = Array.prototype.slice.call(box.querySelectorAll('.opt[data-oud-variant]'));
    var current = pills[0] || null;
    function apply() {
      root.oudVariantId = (check.checked && current) ? Number(current.getAttribute('data-oud-variant')) : null;
      if (current) {
        if (img && current.getAttribute('data-oud-img')) img.src = current.getAttribute('data-oud-img');
        if (priceEl) priceEl.textContent = '+ ' + current.getAttribute('data-price');
      }
      bundleNote(root);
    }
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        pills.forEach(function (q) { q.setAttribute('aria-pressed', 'false'); });
        p.setAttribute('aria-pressed', 'true');
        current = p; apply();
      });
    });
    check.addEventListener('change', function () {
      opts.hidden = !check.checked;
      box.classList.toggle('open', check.checked);
      apply();
    });
    if (img) zoomable(img);
    apply();
  }

  function revealInstantly(root) {
    if (root.classList && root.classList.contains('io')) root.classList.add('in');
    root.querySelectorAll('.io, .aa-hero').forEach(function (el) { el.classList.add('in'); });
  }


  function escHtml(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---------- M2: mobile menu + cart drawer ---------- */
  /* An app on the store blanks the count element when the cart is empty, which
     left "Cart ()" in the header. The parentheses live in their own wrapper now,
     hidden whenever the count is zero. */
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('[data-cart-n]').forEach(function (el) { el.hidden = !n; });
  }

  function money(cents) {
    /* match the storefront's server-side format exactly: R 1,399.00 */
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    return 'R ' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
  }

  function initShell() {
    var overlay = document.querySelector('[data-overlay]');
    var menu = document.querySelector('[data-mobile-menu]');
    var menuBtn = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-cart-drawer]');
    var linesEl = drawer ? drawer.querySelector('[data-cart-lines]') : null;
    var FREE_OVER = 150000; /* cents */

    var lastFocus = null;
    var FOCUSABLE = 'a[href], button:not([disabled]), input, textarea, select, [tabindex]:not([tabindex="-1"])';
    function trap(e) {
      if (e.key !== 'Tab') return;
      var open = document.querySelector('.aa-cart-drawer.open, .aa-mobile-menu.open');
      if (!open) return;
      var items = Array.prototype.filter.call(open.querySelectorAll(FOCUSABLE), function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    document.addEventListener('keydown', trap);

    function show(el, cls) { el.hidden = false; void el.offsetWidth; el.classList.add(cls); }
    function hide(el, cls) { el.classList.remove(cls); setTimeout(function () { el.hidden = true; }, 460); }

    function closeAll() {
      var wasOpen = document.querySelector('.aa-cart-drawer.open, .aa-mobile-menu.open');
      document.documentElement.classList.remove('menu-open', 'drawer-open');
      if (menu && !menu.hidden) hide(menu, 'open');
      if (drawer && !drawer.hidden) hide(drawer, 'open');
      if (overlay && !overlay.hidden) hide(overlay, 'open');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
      if (wasOpen && lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; }
    }
    function openMenu() {
      closeAll();
      document.documentElement.classList.add('menu-open');
      show(menu, 'open'); show(overlay, 'open');
      menuBtn.setAttribute('aria-expanded', 'true');
    }
    function openDrawer() {
      if (!document.querySelector('.aa-cart-drawer.open')) lastFocus = document.activeElement;
      document.documentElement.classList.remove('menu-open');
      if (menu && !menu.hidden) hide(menu, 'open');
      document.documentElement.classList.add('drawer-open');
      show(drawer, 'open');
      if (overlay.hidden) show(overlay, 'open'); else overlay.classList.add('open');
      var close = drawer.querySelector('[data-drawer-close]');
      if (close) setTimeout(function () { close.focus(); }, 60);
      refreshCart();
    }

    if (menuBtn && menu) {
      menuBtn.addEventListener('click', function () {
        if (document.documentElement.classList.contains('menu-open')) closeAll(); else openMenu();
      });
    }
    if (overlay) overlay.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    document.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
    document.querySelectorAll('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!drawer) return;
        e.preventDefault();
        openDrawer();
      });
    });

    function renderCart(cart) {
      setCartCount(cart.item_count);
      if (!linesEl) return;
      if (cart.item_count === 0) {
        linesEl.innerHTML = '<p class="cd-empty">Your cart is empty.<br>' +
          '<a class="textlink" href="/collections/amaani-thobes">Shop thobes</a></p>';
      } else {
        linesEl.innerHTML = cart.items.map(function (it, i) {
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : '';
          return '<div class="cd-line" data-line="' + (i + 1) + '">' +
            (img ? '<img src="' + img + '" alt="" width="64" height="83" loading="lazy">' : '<span></span>') +
            '<div><div class="t">' + escHtml(it.product_title.replace('Amaani ', '')) + '</div>' +
            (it.variant_title ? '<div class="v">' + escHtml(it.variant_title) + '</div>' : '') +
            '<div class="cd-act">' +
              '<div class="qty"><button data-q="-1" aria-label="Decrease quantity">&minus;</button><b>' + it.quantity + '</b><button data-q="1" aria-label="Increase quantity">+</button></div>' +
              '<button class="rm" data-q="0">Remove</button>' +
            '</div></div>' +
            '<div><div class="p">' + money(it.final_line_price) + '</div>' +
            (it.quantity > 1 ? '<div class="ea">' + money(it.final_price) + ' each</div>' : '') + '</div>' +
          '</div>';
        }).join('');
      }
      var sub = drawer.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = money(cart.total_price, cart.currency);
      var del = drawer.querySelector('[data-cart-delivery]');
      if (del) del.textContent = cart.total_price >= FREE_OVER
        ? 'Complimentary delivery applies to this order'
        : 'Complimentary delivery on orders over R1,500';
    }

    function refreshCart() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
    }

    /* Same optimistic, coalesced quantity handling as the cart page. Each click
       used to read the number back out of the DOM, so two quick taps both saw the
       same value and the second silently did nothing. */
    var cdPending = {}, cdTimer = null, cdInFlight = false;

    function cdFlush() {
      if (cdInFlight) return;
      var lines = Array.prototype.slice.call(linesEl.querySelectorAll('[data-line]'));
      if (!lines.length) { cdPending = {}; return; }
      var updates = lines.map(function (el) {
        var n = parseInt(el.getAttribute('data-line'), 10);
        if (cdPending[n] !== undefined) return cdPending[n];
        var q = el.querySelector('.qty b');
        return q ? parseInt(q.textContent, 10) : 1;
      });
      cdPending = {};
      cdInFlight = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function () {
          linesEl.querySelectorAll('[data-busy]').forEach(function (el) { el.removeAttribute('data-busy'); });
        })
        .finally(function () {
          cdInFlight = false;
          if (Object.keys(cdPending).length) cdFlush();
        });
    }

    if (linesEl) {
      linesEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-q]'); if (!btn) return;
        var lineEl = btn.closest('[data-line]'); if (!lineEl) return;
        var line = parseInt(lineEl.getAttribute('data-line'), 10);
        var qEl = lineEl.querySelector('.qty b');
        var base = cdPending[line] !== undefined ? cdPending[line] : (qEl ? parseInt(qEl.textContent, 10) : 1);
        var dq = parseInt(btn.getAttribute('data-q'), 10);
        var next = dq === 0 ? 0 : Math.max(1, base + dq);
        cdPending[line] = next;
        if (next === 0) lineEl.setAttribute('data-busy', '');
        else if (qEl) qEl.textContent = next;
        clearTimeout(cdTimer);
        cdTimer = setTimeout(cdFlush, 320);
      });
    }

    /* add-to-cart -> drawer, no page reload */
    document.querySelectorAll('[data-product-form] form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!drawer) return;
        e.preventDefault();
        /* the notify button borrows .buy-btn styling and sits earlier in the form,
           so match the real submit button explicitly, never just the class */
        var btn = form.querySelector('button[type="submit"].buy-btn');
        var prev = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }
        var rootEl = form.closest('[data-product-form]');
        var items = [{ id: parseInt(form.querySelector('input[name="id"]').value, 10), quantity: 1 }];
        if (rootEl && rootEl.addonVariantId) items.push({ id: rootEl.addonVariantId, quantity: 1 });
        if (rootEl && rootEl.oudVariantId) items.push({ id: rootEl.oudVariantId, quantity: 1 });
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { openDrawer(); })
          .catch(function () { if (btn) btn.textContent = 'Could not add'; })
          .finally(function () { setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = prev; } }, 900); });
      });
    });

    document.addEventListener('click', function (e) {
      var qa = e.target.closest('[data-quick-add]'); if (!qa) return;
      e.preventDefault();
      qa.textContent = 'Adding';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(qa.getAttribute('data-quick-add'), 10), quantity: 1 })
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { openDrawer(); })
        .catch(function () {})
        .finally(function () { setTimeout(function () { qa.textContent = 'Add'; }, 700); });
    });

    refreshCart();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initShell();
    var designMode = window.Shopify && window.Shopify.designMode;
    if (designMode) {
      /* Theme editor re-renders sections on every setting change and the
         entry animations never re-fire, leaving masked text invisible.
         In the editor: no animations, everything visible, always. */
      revealInstantly(document);
    } else {
      initReveals();
    }
    initScroll();
    document.querySelectorAll('[data-size-picker]').forEach(initPicker);
    document.querySelectorAll('[data-product-form]').forEach(initProductForm);
    document.querySelectorAll('[data-product-form]').forEach(initGallery);
    document.querySelectorAll('[data-product-form]').forEach(initAddon);
    document.querySelectorAll('[data-product-form]').forEach(initAddonOud);
    document.querySelectorAll('[data-product-form]').forEach(initColourways);
    document.querySelectorAll('[data-coll-tools]').forEach(initCollectionTools);
    document.querySelectorAll('[data-recent]').forEach(initRecentlyViewed);
    initSearchOverlay();
    initCartPage();
    initQuotes();
  });

  document.addEventListener('shopify:section:load', function (e) {
    revealInstantly(e.target);
    e.target.querySelectorAll('[data-size-picker]').forEach(initPicker);
    e.target.querySelectorAll('[data-product-form]').forEach(initProductForm);
    e.target.querySelectorAll('[data-product-form]').forEach(initColourways);
    e.target.querySelectorAll('[data-recent]').forEach(initRecentlyViewed);
  });
})();
